import { useMemo } from 'react';
import { CurrencyType } from '@libs/types';
import { getAlternativeAssetLabel } from '@libs/helpers';
export const useAssets = (errors, loading, jurisdictionId, data) => {
    const assets = useMemo(() => {
        const defaultOptions = {
            fiatAssets: [],
            filteredFiatAssets: [],
            cryptoAssets: [],
            filteredAllAssets: [],
            enabledCryptoAssets: [],
            allAssets: data || [],
            cryptoWithNetwork: [],
            cashAssets: [],
        };
        if (!data)
            return defaultOptions;
        return data.reduce((acc, assetItem) => {
            const assetLabel = getAlternativeAssetLabel(assetItem.code, jurisdictionId);
            const item = {
                ...assetItem,
                description: assetLabel,
            };
            if (item.code !== CurrencyType.GEL && item.code !== CurrencyType.USD) {
                acc.filteredAllAssets.push(item);
            }
            if (item.isCrypto) {
                acc.cryptoAssets.push(item);
                if (item.isDisabled !== null && !item.isDisabled) {
                    acc.enabledCryptoAssets.push(item);
                    if (item.assetSupportedNetworks?.length) {
                        acc.cryptoWithNetwork?.push(item);
                    }
                }
            }
            else {
                acc.fiatAssets.push(item);
                if (item.code !== CurrencyType.GEL && item.code !== CurrencyType.USD) {
                    acc.filteredFiatAssets.push(item);
                }
                else {
                    acc.cashAssets.push(item);
                }
            }
            return acc;
        }, defaultOptions);
    }, [data, jurisdictionId]);
    return { assets, errors, loading };
};
//# sourceMappingURL=useAssets.js.map